import axios from 'axios';

const DEV_URL = 'http://localhost:8080/api';
const PROD_URL = 'https://www.mementos-proxy.com/api';

const global = axios.create({
  baseURL: PROD_URL,
});

export default global;
